export const featureAbbr = "customer"